<nb-card class="dlg-container mb-0 mobilePopup"
    style="max-height:95vh;max-width:95vw; height: auto !important; width: 1200px; min-height: 200px !important;" *ngIf="isModal">
    <nb-card-header class="d-flex align-items-center title">
        <div class="title">{{helpLabel}}</div>
        <button nbButton static="basic" ghost shape="round" size="small" class="ml-auto" (click)="onClose()">
            <nb-icon icon="close"></nb-icon>
        </button>
    </nb-card-header>

    <nb-card-body class="text-center">
        <div class="video-container">
            <iframe width="560" height="315" [src]="safeUrl" frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen></iframe>
        </div>
    </nb-card-body>
</nb-card>
<div *ngIf="!isModal" title="{{helpLabel}}" class="howto" (click)="onPlayedClick()">
    <span class="fas fa-question-circle"></span>
    <span class="ml-1">How-To Video</span>
</div>